import React, { useState } from 'react'
import { BACKEND_URL_PREFIX, GUEST_SUBGROUP } from '../../utils/const'
import { useGuestLists } from './guest/useGuestLists'
import GuestListModal from './guest/GuestListModal'
import s from './guest/GuestContent.module.scss'

const GuestContent = ({ links }) => {
  const lists = useGuestLists()
  const [openTitle, setOpenTitle] = useState(null)

  return (
    <div className={s.page}>
      <div className={s.cards}>
        {GUEST_SUBGROUP.map(({ name, submenu }) => (
          <section className={s.card} key={name}>
            <h2>{name}</h2>
            <ul>
              {submenu.map(item => {
                const count = lists[item.name]?.items?.length

                return (
                  <li key={item.name}>
                    <button type='button' className={s.item} onClick={() => setOpenTitle(item.name)}>
                      {item.name}
                      {count === undefined ? null : <span className={s.count}>{count}</span>}
                    </button>
                  </li>
                )
              })}
            </ul>
          </section>
        ))}
      </div>

      <aside className={s.links}>
        <h2>Ссылки на сторонние ресурсы</h2>
        {links?.map((link, index) => (
          <a key={index} href={link.link} target='_blank' rel='noopener noreferrer'>
            <span
              className={s.icon}
              style={{
                backgroundImage: `url(${BACKEND_URL_PREFIX}${link.icon.substring(link.icon.indexOf('/links'))})`,
              }}
            />
            {link.title}
          </a>
        ))}
      </aside>

      <GuestListModal title={openTitle} state={lists[openTitle]} onClose={() => setOpenTitle(null)} />
    </div>
  )
}

export default GuestContent
